module.exports = __webpack_public_path__ + "static/7-477d1446aec3fe8a2f95abeca950b9e2.png";